<template>
    <div class="modal fade" id="deleteAccountModal" ref="deleteAccountModal" tabindex="-1" role="dialog" aria-labelledby="deleteAccountModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12 text-center">
                            <h5 class="modal-title-delete-account" id="deleteAccountModalLabel">{{ $t('delete_account.title') }}</h5>
                        </div>
                        <div class="col-12 text-left">
                            <span class="note-text">{{ $t('delete_account.warning_text') }}</span>
                        </div>
                        <div class="col-12 text-left mt-3 mb-3">
                            <input type="password" class="form-control form-control--canvassing border-bottom" :placeholder="$t('delete_account.password')" v-model="password" id="password">
                            <div v-if="hasError(errors, 'password')">
                                <span class="text-danger">{{errors.password[0]}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="deleteAccount" class="modal-footer modal-footer-canvassing-redish">
                    <div class="row w-100">
                        <div class="col-6">
                            <span @click.prevent="deleteAccount" class="modal-footer-canvassing-red-button float-right cursor-pointer">{{ $t('delete_account.delete') }}</span>
                        </div>
                        <div class="col-6">
                            <span data-dismiss="modal" class="modal-footer-canvassing-black-button float-left cursor-pointer">{{ $t('delete_account.cancel') }}</span>
                        </div>
                    </div>
                </div>
                <div v-else class="modal-footer modal-footer-canvassing-grey">
                    <div class="row w-100">
                        <div class="col-6">
                            <span class="modal-footer-canvassing-black-button float-right">{{ $t('delete_account.delete') }}</span>
                        </div>
                        <div class="col-6">
                            <span data-dismiss="modal" class="modal-footer-canvassing-black-button float-left">{{ $t('delete_account.cancel') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "DeleteAccountModal",
        mixins: [HelperMixin],
        data() {
            return {
                password: '',
                errors: {
                    password: []
                }
            }
        },
        created() {
                      
        },
        mounted() {
            $(this.$refs['deleteAccountModal']).on('hide.bs.modal', this.resetDeletePassword);
            $(this.$refs['deleteAccountModal']).on('hide.bs.modal', this.resetDeleteErrors);
        },
        methods: {
             deleteAccount() {
                this.resetDeleteErrors();
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                axios.post(
                        '/api/v1/user/delete',
                        {
                            password: this.password
                        },
                        config
                ).then(this.consumedeleteAccount, this.errordeleteAccount);
            },

            consumedeleteAccount: function (response) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                this.$store.dispatch('forceLogout');
                this.resetDeletePassword();
                $('#deleteAccountModal').modal('hide');
                this.goto('login');
            },

            errordeleteAccount: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                if (
                    error.response !== undefined &&
                    error.response.data !== undefined &&
                    error.response.data.responseType === 'Error' &&
                    error.response.data.errorMessage !== undefined 
                ) {
                    if (typeof error.response.data.errorMessage.validation_fail != 'undefined') {
                        if (typeof error.response.data.errorMessage.validation_fail.password != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.password.includes("required")) {
                                this.errors.password = [this.$t('delete_account.errors.password_required')];
                            }
                            if (error.response.data.errorMessage.validation_fail.password.includes("incorrect")) {
                                this.errors.password = [this.$t('delete_account.errors.password_incorrect')];
                            }
                        }
                    }
                }
               console.log(error);
            },

            resetDeleteErrors() {
                this.errors = {
                    password: []
                };
            },
            resetDeletePassword() {
                this.password = '';
            }
        },
    };
</script>
